import script from "./AnnotationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnotationDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__